<template>
    <section class="margin-both-lg container container--medium" v-if="data && loadingPostsStatus && ( (loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading' )">
        <div class="inner">
            <h2 v-if="data.title" class="titler margin-bottom-md jost jost--35  text-center font--700">{{data.title}}</h2>
            <template v-if="postItems && postItems.length">
			    <EventBlock  v-for="post in postItems" :key="post.id" :post="post" />	
            </template>

            <div v-if="data.show_items === 'small'" class="relation-link text-center">
				<Button class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
						<router-link to="/arrangementer">Se alle arrangementer</router-link>
						<span class="icon">
							<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
						</span>
				</Button>
			</div>
        </div>
    </section>
</template>

<script>
import EventBlock from '@/components/elements/EventBlock'
import Button from '@/components/elements/Button'

import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'events-module',
    components:{
        EventBlock,
        Button
    },
    data(){
        return {
        archiveLinkShow: true,
            postType : 'events',
            postItems: [],
            loadingPostsStatus: false,
        }
    },
    props: ['data'],
    mounted(){
        if(this.data.filter_by === 'venue'){
            this.loadPostsEvents()
        }else if(this.data.events_place && this.data.filter_by === 'place'){
            this.loadPlace()
        }

    },
    methods:{
        ...mapActions([
			'getPost',
        ]),
        loadPlace(){
            const VM = this;
            VM.loadingPostsStatus = 'loading'
            const option = {
                type: 'places',
				limit : 1,
                id: this.data.events_place
            }
            return VM.getPost(option).then(res=>{
                if(res.data && res.data.posts && res.data.posts.length){
                    return res.data.posts[0]
                }else{
                    return false;
                }
            }).then( place =>{
                if( place && place.acf && place.acf.zip_list && place.acf.zip_list.length ){
                    const extraOpt = {
                        meta : 	'zip',
				        value :  place.acf.zip_list
                    }
                    this.loadPostsEvents(extraOpt)
                }
            })
        },
        loadPostsEvents( extraOpt ){
            
            let option = {
                type: this.postType,
				limit : 20,
                orderby: 'event_date',
				order: 'DESC',
            }
            if(this.data.filter_by === 'venue'){
                option.meta = 	'related_venue'
				option.value =  this.data.events_venue
            }
            if(extraOpt){
                option = { ...option, ...extraOpt }
            }

            if(this.data.show_items === 'all'){
                option.limit = 50
            }else{
                option.limit = 3
            }
            

            const VM = this;
            VM.loadingPostsStatus = 'loading'
            return VM.getPost(option).then(res=>{
                if(res.data && res.data.posts && res.data.posts.length){
                    VM.postItems.push(...res.data.posts)
                }
                
                VM.loadingPostsStatus = 'success'
                return VM.loadingPostsStatus;
            })
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-events{


}
</style>